import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

export default function HardwareShowcase() {
  const { t } = useTranslation();

  // 统一的图片过渡遮罩样式
  // 核心逻辑：中心 70% 保持原样，向四周边缘 100% 处平滑淡出到透明，消除图片自带的浅灰底色边框
  const imageMaskStyle = {
    WebkitMaskImage: 'radial-gradient(ellipse at center, rgba(0,0,0,1) 65%, rgba(0,0,0,0) 100%)',
    maskImage: 'radial-gradient(ellipse at center, rgba(0,0,0,1) 65%, rgba(0,0,0,0) 100%)',
  };

  return (
    // 卡片外层区域为纯白背景，完美过渡
    <section className="w-full bg-white py-16 px-6">
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        
        {/* 卡片 1: O-Hygro */}
        {/* 预留: 未来可在此组件内联调试 STM32/ESP32 的实时温湿度数据流 */}
        {/* 卡片 1: O-Hygro */}
{/* 预留: 未来可在此组件内联调试 STM32/ESP32 的实时温湿度数据流 */}
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 300 }}
          className="bg-[#f8f9fa] rounded-[32px] p-10 flex flex-col justify-between border border-gray-100 cursor-pointer group"
        >
        {/* 容器加上 overflow-hidden */}
        <div className="w-full h-[350px] mb-12 flex items-center justify-center overflow-hidden relative">
          <img 
            src={t('hardware.oHygroImagePath')}
            alt="Q-Hygro" 
            // 1. 去掉所有 blend-mode，改用纯透明度过渡，防止叠色发脏
            // 2. 将 scale 放大到 1.15，让图片原有的硬灰色边缘“顶出”到完全透明的遮罩区之外
            className="w-full h-full object-contain scale-[1.15]" 
            // 3. 核心大改动：使用双向线性渐变 + 径向渐变复合遮罩
            // 强制让图片上下左右最外侧的 15% 边缘完全化为透明，彻底抹除方形灰框
            style={{
              WebkitMaskImage: `
                linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 15%, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%),
                linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 15%, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%)
              `,
              maskImage: `
                linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 15%, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%),
                linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 15%, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%)
              `,
              WebkitMaskComposite: 'source-in',
              maskComposite: 'intersect'
            }}
          />
        </div>

        {/* 下半部分：标题与操作 */}
        <div className="flex justify-between items-end">
          <h3 className="text-[clamp(24px,3vw,30px)] font-bold text-gray-900 tracking-wide">
            {t('hardware.oHygro')}
          </h3>
          <div className="flex items-center text-gray-500 group-hover:text-black transition-colors duration-300">
            <span className="text-[clamp(16px,2vw,18px)] font-medium mr-1">{t('hardware.learnMore')}</span>
            <ChevronRight className="w-[clamp(20px,2.5vw,24px)] h-[clamp(20px,2.5vw,24px)]" />
          </div>
        </div>
      </motion.div>

        {/* 卡片 2: O-Bin */}
        {/* 预留: 准备对接包含 500+ BLE 节点的阵列状态 API */}
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 300 }}
          className="bg-[#f8f9fa] rounded-[32px] p-10 flex flex-col justify-between border border-gray-100 cursor-pointer group"
        >
          {/* 上半部分：产品图片容器 */}
          <div className="w-full h-[350px] mb-12 flex items-center justify-center overflow-hidden relative">
            <img 
              src="/assets/images/common/O-bin-card.png" 
              alt="O-Bin" 
              // 1. 去掉突兀的 multiply，改用更适合灰底图过渡的 mix-blend-darken
              // 2. 适当放大整体比例 (scale-[1.05])，让边缘更深地进入羽化区
              className="w-full h-full object-contain scale-[1.05] mix-blend-darken" 
              // 3. 引入椭圆羽化遮罩，完美抹平 O-Bin 图片四周的灰色切边
              style={imageMaskStyle}
            />
          </div>
          
          {/* 下半部分：标题与操作 */}
          <div className="flex justify-between items-end">
            <h3 className="text-[clamp(24px,3vw,30px)] font-bold text-gray-900 tracking-wide">
              {t('hardware.oBin')}
            </h3>
            <div className="flex items-center text-gray-500 group-hover:text-black transition-colors duration-300">
              <span className="text-[clamp(16px,2vw,18px)] font-medium mr-1">{t('hardware.learnMore')}</span>
              <ChevronRight className="w-[clamp(20px,2.5vw,24px)] h-[clamp(20px,2.5vw,24px)]" />
            </div>
          </div>
        </motion.div>

      </div>
    </section>
  );
}